
export class PatientAnamnesisStruct {
    public idPatient: number | null = null;
    public datetimeInclusion?: Date | null = null;
    public listQuestionAnswer: QuestionAnswerStruct[] = [];
}

export class QuestionAnswerStruct {
    public idQuestion: number | null = null;
    public question?: string = '';
    public listAnswer: AnswerStruct[] = [];
    public othersDescription?: string = '';
}

export class AnswerStruct {
    public idAnswer?: number | null = null;
    public answer?: string = '';
}